import type { SVGProps } from 'react';
const SvgImageSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#image_search_svg__a)">
      <path
        fill="currentColor"
        d="M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2Zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18Zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89ZM15.5 9a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z"
      />
    </g>
    <defs>
      <clipPath id="image_search_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgImageSearch;
